import React, {useState} from 'react';
import RestaurantTransactions from '../../Transactions';
import {useLocation, useParams} from 'react-router-dom';
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core';

function SingleRestaurantTransactions() {
  const restaurantId = useParams().restaurantId;
  const [userName, setUserName] = useState('');
  const location = useLocation().pathname.split('/')[1];
  const breadcrumbs: Array<PageLink> = [
    {
      title: 'Transaction',
      path: `${location}/${restaurantId}`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: userName,
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <RestaurantTransactions
        restaurantId={restaurantId}
        showRestaurantFilter={false}
        setUserName={setUserName}
        breadcrumb={<PageTitle breadcrumbs={breadcrumbs}>{userName}</PageTitle>}
      />
    </>
  );
}

export default SingleRestaurantTransactions;
